import React from 'react';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

const LineItemDeliveryReturnMaybe = props => {
  const { lineItems, intl } = props;
  const item = lineItems.find(i => i.code === 'line-item/delivery-return' && !i.reversal);

  if (!item) return null;

  const label = intl.formatMessage({ id: 'OrderBreakdown.deliveryReturn' });
  const formattedTotal = formatMoney(intl, item.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>{label}</span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

export default LineItemDeliveryReturnMaybe;
